import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import DurationPicker from '../DurationPicker';
import { Mobile, Default } from 'components/Responsive';
import { H4, H5, Subtitle2, Caption, Body2 } from 'components/Typography';
import { toDaysHoursAndMinutes, toShortDateStringWithUTCOffset } from 'utilities/formatters/dateTimeFormatter';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import m from 'messages';

class FatigueInformationPanel extends React.Component {

    render() {

        const { classes, editable, fatigueInformation } = this.props;
        const fi = fatigueInformation;

        return (
            <Grid container spacing={1}>
                {fi &&
                    <React.Fragment>
                        <Grid item xs={12} className={classes.wrapper}>
                            <H4>{m.cards.fatigueInformationHeader}</H4>
                            <Caption className={classes.fatigueCaption}>
                                {m.cards.fatigueInformationSubtitle}
                            </Caption>
                        </Grid>

                        <div className={classes.wrapper}></div>

                        <Grid item xs={12}>
                            <Grid container>
                                {editable && fi &&
                                    <Fragment>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelTimeFrom}
                                                </Subtitle2>

                                                <DurationPicker
                                                    hours={fi.lastSwipeInTravelTimeFromPlaceOfRestHours}
                                                    minutes={fi.lastSwipeInTravelTimeFromPlaceOfRestMinutes}
                                                    promptTitle={m.cards.travelTimeFrom}
                                                    onChange={this.props.timeFromWorkChanged}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item md={4} sm={12} xs={12}>
                                            <div className={classes.wrapper}>
                                                <Subtitle2>
                                                    {m.cards.travelTimeTo}
                                                </Subtitle2>
                                                <DurationPicker
                                                    hours={fi.lastSwipeInTravelTimeToPlaceOfRestHours}
                                                    minutes={fi.lastSwipeInTravelTimeToPlaceOfRestMinutes}
                                                    promptTitle={m.cards.travelTimeTo}
                                                    onChange={this.props.timeToWorkChanged}
                                                />
                                            </div>
                                        </Grid>
                                    </Fragment>
                                }
                                <Grid item md={4} sm={12} xs={12}>
                                    <div className={classes.wrapper}>
                                        <Subtitle2>{m.cards.timeSinceLastSwipe}</Subtitle2>
                                        <Body2>
                                            {fi.swipedIn ? m.cards.stillSwipedIn : toDaysHoursAndMinutes(fi.timeSinceLastSwipeOutInMin, false)}
                                        </Body2>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>

                        <div className={classes.wrapper}></div>

                        {fi.previousLocations && fi.previousLocations.length > 0 &&
                            <Grid item xs={12}>
                                <H5 paragraph>{m.cards.previousLocations}</H5>

                                <Default>
                                    <Grid container>
                                        <Grid item sm={3}>
                                            <Subtitle2>
                                                {m.cards.site}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Subtitle2>
                                                {m.cards.timeIn}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Subtitle2>
                                                {m.cards.timeOut}
                                            </Subtitle2>
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Subtitle2>
                                                {m.cards.lastShiftDuration}
                                            </Subtitle2>
                                        </Grid>
                                    </Grid>
                                </Default>
                            </Grid>
                        }

                        {fi.previousLocations && fi.previousLocations.map((pl, index) =>
                            <Grid key={index} item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.previousSite}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {pl.lastKnownSiteName}
                                        </Body2>
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.timeSwipedIn}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toShortDateStringWithUTCOffset(pl.lastKnownSwipeInTimeLocal, pl.lastKnownSwipeInTimeLocalUTCOffset)}
                                        </Body2>
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.timeSwipedOut}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toShortDateStringWithUTCOffset(pl.lastKnownSwipeOutTimeLocal, pl.lastKnownSwipeOutTimeLocalUTCOffset)}
                                        </Body2>
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <Mobile>
                                            <Subtitle2>{m.cards.lastShiftDuration}</Subtitle2>
                                        </Mobile>
                                        <Body2>
                                            {toDaysHoursAndMinutes(pl.lastKnownShiftDurationInMin, false)}
                                        </Body2>
                                    </Grid>
                                </Grid>
                                <Divider className={classes.divider} />
                            </Grid>
                        )}
                    </React.Fragment>
                }
            </Grid>
        );
    }
}

FatigueInformationPanel.propTypes = {
    editable: PropTypes.bool,
    fatigueInformation: PropTypes.object
};

export default withStyles(styles)(FatigueInformationPanel);

